import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import Bubble from '@propertypal/shared/src/resources/icons/prime/bubble.svg';
import Exposure from '@propertypal/shared/src/resources/icons/prime/exposure.svg';
import Laptop from '@propertypal/shared/src/resources/icons/prime/laptop.svg';
import platform from '@propertypal/shared/src/utils/platform';
import React from 'react';
import FontAwesomeIcon from '../../icons/FontAwesomeIcon';
import { Bold, Heading, Text } from '../../typography';
import { TiersGrid } from './PrimeTiers.style';
import {
  WhyPrimeCardTitle,
  WhyPrimeCard,
  WhyPrimeCardIconWrapper,
  WhyPrimeContainer,
  WhyPrimeWrapper,
  WhyPrimeCardList,
  WhyPrimeCardListItem,
  WhyPrimeCardBox,
  WhyPrimeLink,
} from './WhyPrime.style';

interface WhyPrimeProps {}

const WhyPrime: React.FC<WhyPrimeProps> = () => {
  return (
    <WhyPrimeContainer>
      <WhyPrimeWrapper data-testid="why-prime">
        <Heading mb={40} fontSize={40} align="center">
          Why {platform.title} Prime works for you
        </Heading>
        <TiersGrid>
          <WhyPrimeCard>
            <WhyPrimeCardIconWrapper>
              <Exposure />
            </WhyPrimeCardIconWrapper>
            <WhyPrimeCardTitle maxWidth={180}>More Exposure for Your Brand</WhyPrimeCardTitle>
            <WhyPrimeCardList>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>Appear higher in search when buyers are actively looking.</Text>
              </WhyPrimeCardListItem>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>Enhanced branding keeps your agency front and centre.</Text>
              </WhyPrimeCardListItem>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>More visibility helps drive future instructions.</Text>
              </WhyPrimeCardListItem>
            </WhyPrimeCardList>
          </WhyPrimeCard>
          <WhyPrimeCard>
            <WhyPrimeCardIconWrapper>
              <Bubble />
            </WhyPrimeCardIconWrapper>
            <WhyPrimeCardTitle maxWidth={160}>Drive More Enquiries</WhyPrimeCardTitle>
            <WhyPrimeCardList>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>Get more interest as soon as your listing goes live.</Text>
              </WhyPrimeCardListItem>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>Reach more active buyers while demand is highest.</Text>
              </WhyPrimeCardListItem>
              <WhyPrimeCardListItem>
                <FontAwesomeIcon icon={faCheck} />
                <Text>Turn visibility into more leads.</Text>
              </WhyPrimeCardListItem>
            </WhyPrimeCardList>
          </WhyPrimeCard>
          <WhyPrimeCard>
            <WhyPrimeCardIconWrapper>
              <Laptop />
            </WhyPrimeCardIconWrapper>
            <WhyPrimeCardTitle maxWidth={280}>You Benefit When Vendors Upgrade Directly</WhyPrimeCardTitle>
            <Text align="center">
              If a vendor upgrades through our website, member agents receive 20% commercial rebate
            </Text>
            <WhyPrimeCardBox>
              <Bold as="b" mb={12}>
                Rebates are:
              </Bold>
              <ul>
                <li>Applied automatically</li>
                <li>Instantly available in your balance</li>
                <li>Usable against invoices or future Prime advertisements</li>
              </ul>
            </WhyPrimeCardBox>
          </WhyPrimeCard>
        </TiersGrid>
        <WhyPrimeLink href="/news-and-analysis/marketing-your-property/how-prime-adverts-work">
          Read more about how {platform.title} Prime Adverts work
        </WhyPrimeLink>
      </WhyPrimeWrapper>
    </WhyPrimeContainer>
  );
};

export default WhyPrime;
